import * as React from "react";
import { Header, Button, TextArea, Form } from "semantic-ui-react";
import RecordCard from "./RecordCard";

type TlgProdColumnProps = {
  tlgProd: State.ColumnState;
  isPushing: boolean;
  onRequestLota: (comment: string) => void;
};

type TlgProdColumnState = {
  comment: string;
};

class TlgProdColumn extends React.Component<TlgProdColumnProps, TlgProdColumnState> {
  state: TlgProdColumnState = {
    comment: "",
  };

  private handleCommentChange = (_e: React.FormEvent, data: any): void => {
    this.setState({ comment: data.value });
  };

  private handleRequestLota = (): void => {
    this.props.onRequestLota(this.state.comment);
    this.setState({ comment: "" });
  };

  render(): JSX.Element {
    const { tlgProd, isPushing } = this.props;
    const { comment } = this.state;

    return (
      <div>
        <Header as="h3" dividing>
          TLG Prod
        </Header>
        <RecordCard
          record={tlgProd.record}
          viewJson={tlgProd.viewJson}
          isFetching={tlgProd.isFetching}
          fetchError={tlgProd.fetchError}
          title="Current Prod Record"
        />
        {tlgProd.record && (
          <Form style={{ marginTop: "1em" }}>
            <Form.Field>
              <label>Comment for LOTA request</label>
              <TextArea
                placeholder="Add a comment for the LOTA push request..."
                value={comment}
                onChange={this.handleCommentChange}
              />
            </Form.Field>
            <Button
              color="orange"
              fluid
              loading={isPushing}
              disabled={isPushing}
              onClick={this.handleRequestLota}
            >
              Request LOTA Push
            </Button>
          </Form>
        )}
      </div>
    );
  }
}

export default TlgProdColumn;
